import { render } from "./ArtistListing.vue?vue&type=template&id=c5823688"
import script from "./ArtistListing.vue?vue&type=script&lang=js"
export * from "./ArtistListing.vue?vue&type=script&lang=js"
script.render = render

export default script